import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { GameCenterComponentGridAreas } from '../../styles';

export const PlayoffsRecordContainer = styled.div`
    ${BaseStyle.Mixins.gaps.semiMedium}
    display: flex;
    flex-direction: column;
    grid-area: ${GameCenterComponentGridAreas.lastTenOrPlayoffsRecord};

    ${BaseStyle.Mixins.screenSizes.large} {
        padding: 0 24px;
    }
`;

export const Header = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['20b']}
`;

export const TeamContainer = styled.div`
    ${BaseStyle.Mixins.gaps.extraSmall};
    align-items: center;
    border: 1px solid ${({ theme }) => theme.Surface.border};
    border-radius: 8px;
    display: flex;
    padding: 12px;
`;

export const TeamLogoContainer = styled.div`
    img {
        height: 40px;
        width: 60px;
    }
`;

export const TeamName = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['24b']}
`;

export const RecordContainer = styled.div`
    align-items: end;
    display: flex;
    flex: 1;
    flex-direction: column;
`;

export const Record = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['24b']}
`;

export const Streak = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14']}
    color: ${({ theme }) => theme.Text.secondary};
    height: 16px;
`;
